import { ElementRef, inject, Renderer2 } from '@angular/core'
import kebabCase from 'just-kebab-case'

export function injectSetPayloadAttributeFn() {
  const renderer = inject(Renderer2)
  const elRef = inject(ElementRef)

  return (block: { id: string; __typename: string }) => {
    renderer.setAttribute(elRef.nativeElement, 'data-block-id', block.id)
    renderer.setAttribute(elRef.nativeElement, 'data-block-slug', kebabCase(block.__typename))
  }
}
